/**
 * Roles a person can hold inside an organisation (a Hub tenant), as stored in
 * tenant_memberships.role. They never add data access: what someone can open
 * comes from their persona per Business Case (Keycloak). An organisation role
 * only adds member management (Admin) or takes writes away (Auditor).
 */
export const TENANT_ROLE_OPTIONS = [
  {
    value: 'tenant_user',
    label: 'User',
    description: 'Uses the Hub with the rights of their persona.',
  },
  {
    value: 'tenant_auditor',
    label: 'Auditor',
    description: 'Read-only: sees what their persona allows but cannot change anything.',
  },
  {
    value: 'tenant_admin',
    label: 'Admin',
    description: "Also manages this organisation's members and invitations and sees its activity.",
  },
];

const LABELS = Object.fromEntries(TENANT_ROLE_OPTIONS.map((option) => [option.value, option.label]));

export const tenantRoleLabel = (role) => LABELS[role] || 'User';
